// extracted by mini-css-extract-plugin
export default {"feedback":"GJ5FIgEyvouHquOcpqSB","feedback-buttons":"NHU_kSF2DgjxUlCzhDOX"};